import axios from "axios";
// import { jwtDecode } from "jwt-decode";
import { SALENG_GREEN_API_PROD, SALENG_SHOP_API_PROD } from "./../config";

const SALENG_GREEN_API = SALENG_GREEN_API_PROD
const SALENG_SHOP_API = SALENG_SHOP_API_PROD

// Auth
export const loginGreen = (payload) => {
    return axios.post(`${SALENG_GREEN_API}/auth/login`, payload, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Categories
export const getCategories = () => {
    return axios.get(`${SALENG_GREEN_API}/categories`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Product
export const getProducts = (shopId) => {
    return axios.get(`${SALENG_SHOP_API}/products/${shopId}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const createProduct = (payload, shopId) => {
    return axios.post(`${SALENG_SHOP_API}/products`, { ...payload, shopId: shopId }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const deleteProduct = (id, shopId) => {
    return axios.delete(`${SALENG_SHOP_API}/products/${shopId}/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const updateProduct = (id, payload, shopId) => {
    return axios.put(`${SALENG_SHOP_API}/products/${shopId}/${id}`, payload, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Shop
export const getShop = (shopId) => {
    return axios.get(`${SALENG_SHOP_API}/shop/${shopId}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const createShop = (payload, shopId) => {
    return axios.post(`${SALENG_SHOP_API}/shop`, { ...payload, shopId: shopId }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Branchs
export const getBranch = (branchId) => {
    return axios.get(`${SALENG_SHOP_API}/branches/${branchId}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const createBranch = (payload, shopId) => {
    return axios.post(`${SALENG_SHOP_API}/branches`, { ...payload, shopId: shopId }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const deleteBranch = (id, shopId) => {
    return axios.delete(`${SALENG_SHOP_API}/branches/${shopId}/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const updateBranch = (id, payload, shopId) => {
    return axios.put(`${SALENG_SHOP_API}/branches/${shopId}/${id}`, payload, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Users
export const getUser = (id) => {
    return axios.get(`${SALENG_GREEN_API}/users/` + id, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const createUser = (payload, shopId) => {
    return axios.post(`${SALENG_SHOP_API}/users`, { ...payload, shopId: shopId }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const deleteUser = (id, shopId) => {
    return axios.delete(`${SALENG_SHOP_API}/users/${shopId}/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const updateUser = (id, payload, shopId) => {
    return axios.put(`${SALENG_SHOP_API}/users/${shopId}/${id}`, payload, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};



// Transaction
export const getTransaction = (transactionId) => {
    return axios.get(`${SALENG_SHOP_API}/transaction/` + transactionId, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const getShopTransaction = (shopId) => {
    return axios.get(`${SALENG_SHOP_API}/transaction/shop/${shopId}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const getBranchTransaction = (branchId) => {
    return axios.get(`${SALENG_SHOP_API}/transaction/branch/${branchId}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const uploadFile = (formData) =>
    fetch(`${SALENG_SHOP_API}/files`, {
        method: 'POST',
        body: formData,
    });
